import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Prescrition } from '../../configurator/models/Prescriptions';

export type PrescriptionState ={
    currentPrescription:Prescrition,
    previousPrescription:Prescrition
}

const initialState:PrescriptionState = {
    currentPrescription:null,
    previousPrescription:null
};

const PrescriptionSlice = createSlice({
    name: 'prescription',
    initialState: initialState,
    reducers: {
        setCurrentPrescription: (state, { payload }: PayloadAction<Prescrition>) => {
            state.currentPrescription=payload;
        },
        setPreviousPrescription: (state, { payload }: PayloadAction<Prescrition>) => {
            state.previousPrescription=payload;
        },
    },
  });

export const prescriptionReducer = PrescriptionSlice.reducer;
export const prescriptionActions = PrescriptionSlice.actions;